import { render, staticRenderFns } from "./worksComponent.vue?vue&type=template&id=66eadc3c"
import script from "./worksComponent.vue?vue&type=script&lang=js"
export * from "./worksComponent.vue?vue&type=script&lang=js"
import style0 from "./worksComponent.vue?vue&type=style&index=0&id=66eadc3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports